import _ from 'lodash';

export interface SystemDialog {
  header: string | null;
  paragraphs: string[] | null;
  approveButton: SystemDialogButton | null;
  cancelButton: SystemDialogButton | null;
}

export interface SystemDialogButton {
  type: 'link' | 'button';
  text: string;
  to?: string;
}

function getState(): SystemDialog {
  return {
    header: null,
    paragraphs: null,
    approveButton: null,
    cancelButton: null
  };
}

export const state = getState();

export const mutations = {
  setContent(
    state: any,
    { header, paragraphs, approveButton, cancelButton }: SystemDialog
  ): void {
    state.header = header;
    state.paragraphs = paragraphs;
    state.approveButton = approveButton;
    state.cancelButton = cancelButton;
  },

  clear(state: any) {
    const newState = getState();
    Object.keys(state).forEach(key => {
      state[key] = newState[key];
    });
  }
};
